import BaseScreen from "../BaseScreen";
import {
  Image,
  Pressable,
  StyleSheet,
  Text,
  TextInput,
  View,
  Platform,
} from "react-native";
import NavBar from "../../components/NavBar";
import {
  color_main,
  color_BEBEBE,
  black,
  ColorLine,
  color_333333,
} from "../../assets/style/colors";
import { MainNavProps } from "../navigation/main/MainParamList";
import React, { useState } from "react";
import { ImageView } from "../../components/ImageView";
import { changePsd } from "../../net/service";
import { showToast } from "../../components/Toast";
import { hideLoading, showLoading } from "../../components/Loading";
import {
  Str_ChangeFail,
  Str_ChangeSuc,
  Str_Complete,
  Str_ConfirmPsd,
  Str_InputNewPsd,
  Str_InputNewPsdAgain,
  Str_InputOldPsd,
  Str_NewPsd,
  Str_OldPsd,
  Str_PasswordCannotBeSame,
  Str_PsdFormatErr,
  Str_PsdInconsistent,
  Str_PsdLengthErr1,
  Str_PsdLengthErr2,
  Str_PsdNotNull,
  Str_PsdOldLengthErr1,
  Str_PsdOldLengthErr2,
  Str_PsdOldNotNull,
  Str_UpdatePsdLoading,
  Str_UpdatePsdTitle,
} from "../../language/string_res";
import { validatePassword } from "../login/register";
import { CryptEngine } from "../../utils/CryptEngine";
import { ScreenCloseModal, ScreenModal } from "../../components/ScreenModal";

export function UpdatePsdSetting({
  navigation,
}: MainNavProps<"UpdatePsdSetting">) {
  const [oldPsd, setOldPsd] = useState("");
  const [newPsd, setNewPsd] = useState("");
  const [newPsdAgain, setNewPsdAgain] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setNewShowPassword] = useState(false);
  const [showNewAgainPassword, setNewAgainShowPassword] = useState(false);

  function submit() {
    if (oldPsd.trim().length <= 0) {
      showToast(Str_PsdOldNotNull);
      return;
    }
    if (oldPsd.trim().length < 8) {
      showToast(Str_PsdOldLengthErr1);
      return;
    }
    if (oldPsd.trim().length > 32) {
      showToast(Str_PsdOldLengthErr2);
      return;
    }
    if (newPsd.trim().length <= 0) {
      showToast(Str_PsdNotNull);
      return;
    }
    if (newPsd.trim().length < 8) {
      showToast(Str_PsdLengthErr1);
      return;
    }
    if (newPsd.trim().length > 32) {
      showToast(Str_PsdLengthErr2);
      return;
    }
    if (!validatePassword(newPsd)) {
      showToast(Str_PsdFormatErr);
      return;
    }
    if (newPsd.trim() === oldPsd.trim()) {
      showToast(Str_PasswordCannotBeSame);
      return;
    }
    if (newPsd.trim() !== newPsdAgain.trim()) {
      showToast(Str_PsdInconsistent);
      return;
    }
    showLoading(Str_UpdatePsdLoading);
    const psdMd5 = CryptEngine.md5(oldPsd.trim());
    const engineNew = CryptEngine.md5(newPsd.trim());
    changePsd({ passwd: psdMd5, newPasswd: engineNew })
      .then((res) => {
        if (res.code === 0) {
          showToast(Str_ChangeSuc);
          navigation.goBack();
        } else {
          showToast(res.msg || Str_ChangeFail);
        }
      })
      .finally(() => {
        hideLoading();
      });
  }

  return (
    <ScreenCloseModal title={Str_UpdatePsdTitle}>
      <View style={styles.webFormContainer}>
        <View style={styles.webFormField}>
          <Text style={styles.webLabel}>{Str_OldPsd}</Text>
          <View style={styles.webInputWrapper}>
            <TextInput
              placeholder={Str_InputOldPsd}
              editable={true}
              focusable={true}
              selectionColor={color_main}
              placeholderTextColor={color_BEBEBE}
              style={styles.webInput}
              value={oldPsd}
              secureTextEntry={!showPassword}
              onChangeText={(text) => {
                setOldPsd(text);
              }}
            />
            {oldPsd.length > 0 && (
              <View style={styles.webInputActions}>
                <Pressable
                  onPress={() => setShowPassword(!showPassword)}
                  style={styles.iconButton}
                >
                  <Image
                    source={
                      showPassword
                        ? require("../../assets/image/icon_eye.png")
                        : require("../../assets/image/icon_close_eye.png")
                    }
                    style={styles.eyeIcon}
                    resizeMode="contain"
                  />
                </Pressable>
                <ImageView
                  onClick={() => setOldPsd("")}
                  source={require("../../assets/image/icon_del.png")}
                />
              </View>
            )}
          </View>
        </View>

        <View style={styles.webFormField}>
          <Text style={styles.webLabel}>{Str_NewPsd}</Text>
          <View style={styles.webInputWrapper}>
            <TextInput
              placeholder={Str_InputNewPsd}
              editable={true}
              focusable={true}
              selectionColor={color_main}
              placeholderTextColor={color_BEBEBE}
              style={styles.webInput}
              value={newPsd}
              secureTextEntry={!showNewPassword}
              onChangeText={(text) => {
                setNewPsd(text);
              }}
            />
            {newPsd.length > 0 && (
              <View style={styles.webInputActions}>
                <Pressable
                  onPress={() => setNewShowPassword(!showNewPassword)}
                  style={styles.iconButton}
                >
                  <Image
                    source={
                      showNewPassword
                        ? require("../../assets/image/icon_eye.png")
                        : require("../../assets/image/icon_close_eye.png")
                    }
                    style={styles.eyeIcon}
                    resizeMode="contain"
                  />
                </Pressable>
                <ImageView
                  onClick={() => setNewPsd("")}
                  source={require("../../assets/image/icon_del.png")}
                />
              </View>
            )}
          </View>
        </View>

        <View style={styles.webFormField}>
          <Text style={styles.webLabel}>{Str_ConfirmPsd}</Text>
          <View style={styles.webInputWrapper}>
            <TextInput
              placeholder={Str_InputNewPsdAgain}
              editable={true}
              focusable={true}
              selectionColor={color_main}
              placeholderTextColor={color_BEBEBE}
              style={styles.webInput}
              value={newPsdAgain}
              secureTextEntry={!showNewAgainPassword}
              onChangeText={(text) => {
                setNewPsdAgain(text);
              }}
            />
            {newPsdAgain.length > 0 && (
              <View style={styles.webInputActions}>
                <Pressable
                  onPress={() => setNewAgainShowPassword(!showNewAgainPassword)}
                  style={styles.iconButton}
                >
                  <Image
                    source={
                      showNewAgainPassword
                        ? require("../../assets/image/icon_eye.png")
                        : require("../../assets/image/icon_close_eye.png")
                    }
                    style={styles.eyeIcon}
                    resizeMode="contain"
                  />
                </Pressable>
                <ImageView
                  onClick={() => setNewPsdAgain("")}
                  source={require("../../assets/image/icon_del.png")}
                />
              </View>
            )}
          </View>
        </View>

        <Pressable onPress={submit} style={styles.submitButton}>
          <Text style={styles.submitButtonText}>{Str_Complete}</Text>
        </Pressable>
      </View>
    </ScreenCloseModal>
  );
}

const styles = StyleSheet.create({
  // BaseScreen 样式
  baseScreen: {
    ...(Platform.OS === "web"
      ? {
          backgroundColor: "white",
        }
      : {
          alignItems: "center",
        }),
  },

  // 移动端卡片容器
  cardContainer: {
    backgroundColor: "white",
    borderRadius: 16,
    padding: 24,
    minHeight: 450,
    width: "100%",
  },
  // Web 表单容器
  webFormContainer: {
    paddingHorizontal: 24,
    paddingTop: 24,
    flex: 1,
    width: "100%",
    ...(Platform.OS === "web" && {
      maxWidth: 600,
      alignSelf: "center",
      paddingHorizontal: 40,
      paddingTop: 60,
      paddingBottom: 60,
    }),
  },
  // Web 表单字段
  webFormField: {
    marginBottom: 24,
  },
  // Web 标签样式
  webLabel: {
    color: black,
    fontSize: 14,
    fontWeight: "500",
    marginBottom: 8,
  },
  // Web 输入框包装器
  webInputWrapper: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 1,
    borderColor: "#E0E0E0",
    borderRadius: 8,
    paddingHorizontal: 16,
    minHeight: 48,
    backgroundColor: "white",
    ...(Platform.OS === "web" && {
      transition: "border-color 0.2s",
    }),
  },
  // Web 输入框样式
  webInput: {
    flex: 1,
    height: 48,
    color: color_333333,
    fontSize: 16,
  },
  // Web 输入框操作按钮容器
  webInputActions: {
    flexDirection: "row",
    alignItems: "center",
    marginLeft: 8,
  },
  // 移动端标签样式
  mobileLabel: {
    color: black,
    fontSize: 16,
    fontWeight: "500",
  },
  // 移动端输入框容器
  inputBg: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 16,
    paddingHorizontal: 20,
    minHeight: 56,
  },
  // 移动端输入框样式
  input: {
    height: 48,
    flex: 1,
    marginStart: 16,
    color: color_333333,
    fontSize: 16,
  },
  // 图标按钮样式
  iconButton: {
    ...(Platform.OS === "web" && {
      cursor: "pointer",
      userSelect: "none",
    }),
  },
  eyeIcon: {
    width: 20,
    height: 20,
    tintColor: "#999",
    marginEnd: 8,
  },
  // 按钮容器
  buttonContainer: {
    marginTop: 60,
    alignItems: "center",
  },
  // 提交按钮样式
  submitButton: {
    backgroundColor: color_main,
    marginTop: 32,
    borderRadius: 8,
    paddingVertical: 12,
    paddingHorizontal: 32,
    minWidth: 120,
    alignItems: "center",
    justifyContent: "center",
    ...(Platform.OS === "web" && {
      cursor: "pointer",
      userSelect: "none",
      transition: "opacity 0.2s, background-color 0.2s",
    }),
  },
  submitButtonText: {
    color: "white",
    fontSize: 16,
    fontWeight: "600",
  },
});
